import { slide as Menu } from "react-burger-menu";
import "./Menu.css";
import React from "react";
import { NavLink } from "react-router-dom";

function MenuComponent() {
  return (
    <Menu right>
      <NavLink to="/" id="home" className="menu-item">
        HOME
      </NavLink>
      <NavLink to="/aboutus" id="home" className="menu-item">
        ABOUT US
      </NavLink>
      <NavLink to="/exports" id="home" className="menu-item">
        EXPORTS
      </NavLink>
      <NavLink to="/media" id="home" className="menu-item">
        MEDIA
      </NavLink>
      <NavLink to="/products" id="home" className="menu-item">
        PRODUCTS
      </NavLink>
      <NavLink to="/recipes" id="home" className="menu-item">
        RECIPES
      </NavLink>
      <NavLink to="/contactus" id="home" className="menu-item">
        CONTACT
      </NavLink>
    </Menu>
  );
}

export default MenuComponent;
